// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guides__content-wrapper {
    background-color: white;
    min-height: calc(100vh - 1px);
    display: flex;
    flex-direction: column;
    padding: 18px 24px 24px 0;
    gap: 24px;
}

.guides__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 160px;
    gap: 16px;
}

.guides__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    padding: 24px;
    background-color: #f2f2f2;
    border-radius: 10px;
}

.guides__page-filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.guides__page-title {
    font-size: 20px;
    line-height: 25px;
    font-weight: 500;
    color: #191919;
}

.guides__list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
    gap: 16px;
}

.guides__guide-item {
    padding: 24px;
    background-color: #FFFFFF;
    width: 100%;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/Guides/Guides.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".guides__content-wrapper {\n    background-color: white;\n    min-height: calc(100vh - 1px);\n    display: flex;\n    flex-direction: column;\n    padding: 18px 24px 24px 0;\n    gap: 24px;\n}\n\n.guides__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: 160px;\n    gap: 16px;\n}\n\n.guides__content {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 16px;\n    padding: 24px;\n    background-color: #f2f2f2;\n    border-radius: 10px;\n}\n\n.guides__page-filters {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n}\n\n.guides__page-title {\n    font-size: 20px;\n    line-height: 25px;\n    font-weight: 500;\n    color: #191919;\n}\n\n.guides__list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));\n    gap: 16px;\n}\n\n.guides__guide-item {\n    padding: 24px;\n    background-color: #FFFFFF;\n    width: 100%;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
